<template>
  <div>
    <div class="container-fluid">
      <div class="page-header">
        <Breadcrumbs main="Super Admin" title="Activity" />
      </div>

      <div class="card">
        <div class="card-header">
          <div class="d-flex flex-wrap justify-content-between align-items-center">
            <h5 class="mb-0">Activity log <small class="text-muted">({{ total }})</small></h5>
            <button
              type="button"
              class="btn btn-outline-secondary btn-sm mt-2 mt-md-0"
              :disabled="loading || !total"
              @click="exportCsv"
            >
              <feather type="download" size="14" class="mr-1"></feather>Export CSV
            </button>
          </div>
          <p class="text-muted small mb-0 mt-2">
            Subscription lifecycle events (checkouts, webhooks, cancellations and admin actions).
          </p>
          <p class="text-danger mb-0 mt-2" v-if="actionError">{{ actionError }}</p>
        </div>
        <div class="card-body">
          <div v-if="loading" class="text-center py-5">
            <div class="spinner-border text-primary" role="status"></div>
            <p class="text-muted mt-3 mb-0">Loading events...</p>
          </div>
          <div v-else-if="loadError" class="text-center py-5">
            <p class="text-danger mb-0">{{ loadError }}</p>
            <button class="btn btn-outline-primary btn-sm mt-3" @click="load">Retry</button>
          </div>
          <template v-else>
            <div class="table-responsive datatable-vue text-center">
              <b-table
                show-empty
                striped
                hover
                head-variant="light"
                bordered
                stacked="md"
                :items="events"
                :fields="fields"
              >
                <template #empty><span>No event recorded yet.</span></template>
                <template #cell(createdAt)="field">{{ formatDateTime(field.item.createdAt) }}</template>
                <template #cell(userEmail)="field">{{ field.item.userEmail || "—" }}</template>
                <template #cell(provider)="field"><span class="text-capitalize">{{ field.item.provider || "—" }}</span></template>
                <template #cell(eventType)="field"><code>{{ field.item.eventType }}</code></template>
              </b-table>
            </div>
            <b-col md="12" class="my-1 p-0 pagination-justify" v-if="total > limit">
              <b-pagination
                :value="currentPage"
                :total-rows="total"
                :per-page="limit"
                @input="onPageChange"
                class="mt-4"
              ></b-pagination>
            </b-col>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "@/utils/firestore-shim";
import { downloadCSV } from "@/utils/store-stats";

export default {
  name: "AdminEvents",
  data() {
    return {
      fields: [
        { key: "createdAt", label: "Date" },
        { key: "userEmail", label: "User" },
        { key: "provider", label: "Provider" },
        { key: "eventType", label: "Event" }
      ],
      events: [],
      total: 0,
      limit: 50,
      offset: 0,
      currentPage: 1,
      loading: false,
      loadError: "",
      actionError: ""
    };
  },
  mounted() {
    this.load();
  },
  methods: {
    formatDateTime(value) {
      if (!value) return "—";
      const d = new Date(value);
      return isNaN(d.getTime()) ? String(value) : d.toLocaleString();
    },
    async load() {
      this.loading = true;
      this.loadError = "";
      this.actionError = "";
      try {
        const res = await firebase.api.get("/admin/events?limit=" + this.limit + "&offset=" + this.offset);
        this.events = (res && res.events) || [];
        this.total = (res && res.total) || 0;
      } catch (e) {
        this.loadError = "Could not load events: " + ((e && e.message) || e);
      } finally {
        this.loading = false;
      }
    },
    onPageChange(page) {
      this.currentPage = page;
      this.offset = (page - 1) * this.limit;
      this.load();
    },
    async exportCsv() {
      try {
        const res = await firebase.api.get("/admin/events?limit=10000&offset=0");
        const rows = ((res && res.events) || []).map((ev) => ({
          Date: ev.createdAt || "",
          User: ev.userEmail || "",
          Provider: ev.provider || "",
          Event: ev.eventType || "",
          "Subscription": ev.subscriptionId || ""
        }));
        downloadCSV(rows, "activity-" + new Date().toISOString().slice(0, 10) + ".csv");
      } catch (e) {
        this.actionError = "Unable to export: " + ((e && e.message) || e);
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
